import { ORDER_DETAILS_DATA, ORDER_DETAILS_ERROR_DATA, ORDER_DETAILS_HIDE_ERROR_DATA, ORDER_DETAILS_START_LOADER, ORDER_DETAILS_STOP_LOADER, ORDER_DETAILS_CLEAR_DATA, } from "../interface/IOrderDetails";
const initState = {
    data: {
        orderDetails: [],
    },
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const orderDetails = (state = initState, action) => {
    switch (action.type) {
        case ORDER_DETAILS_DATA: {
            return Object.assign(Object.assign({}, state), { data: action.payload.orderDetails });
        }
        case ORDER_DETAILS_CLEAR_DATA:
            return Object.assign(Object.assign({}, state), { data: initState.data });
        case ORDER_DETAILS_ERROR_DATA:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case ORDER_DETAILS_HIDE_ERROR_DATA:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case ORDER_DETAILS_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case ORDER_DETAILS_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default orderDetails;
